import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { webGames } from '../data/games';
import './Home.css';

const Home = () => {
  return (
    <>
      <SEO
        title="Home"
        description="Play free online puzzle and arcade games at IdeaPetal Games, including Mines Garden, Snake Garden, Memory Bloom, and Petal 2048."
        keywords="online games, mini games, free games, play games, IdeaPetal, minesweeper, snake, 2048, memory games"
      />
      <div className="home-page">
        <section
          className="hero-section"
          style={{
            backgroundImage: `linear-gradient(90deg, rgba(22, 31, 54, 0.86) 0%, rgba(22, 31, 54, 0.58) 42%, rgba(22, 31, 54, 0.08) 100%), url(${process.env.PUBLIC_URL}/images/games/hero-games.png)`,
          }}
        >
          <div className="hero-content">
            <h1>Welcome to IdeaPetal Games</h1>
            <p className="hero-subtitle">Play Free Online Mini Games Anytime, Anywhere</p>
            <p className="hero-description">
              Discover quick, replayable browser games built for short breaks, daily challenges, and score chasing.
            </p>
            <Link to="/games" className="cta-button">
              Play Games Now
            </Link>
          </div>
        </section>

        <section className="features-section">
          <div className="container">
            <h2>Why Choose IdeaPetal Games?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">Free</div>
                <h3>Free to Play</h3>
                <p>All games are free to play in your browser with no required downloads.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">Web</div>
                <h3>Play Anywhere</h3>
                <p>Play on desktop, tablet, or mobile with simple keyboard and touch-friendly controls.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">New</div>
                <h3>Regular Updates</h3>
                <p>New puzzle and arcade games can be added to the same growing game collection.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">Easy</div>
                <h3>Easy to Play</h3>
                <p>Simple rules make each game quick to learn and satisfying to replay.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="popular-games-section">
          <div className="container">
            <h2>Popular Games</h2>
            <div className="games-preview">
              {webGames.slice(0, 4).map((game) => (
                <div className="game-card" key={game.id}>
                  <img className="game-thumbnail" src={game.image} alt={`${game.name} game preview`} />
                  <h3>{game.name}</h3>
                  <p>{game.description}</p>
                  <Link to={`/games/${game.slug}#play`} className="play-button">
                    Play Game
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
